
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Remarketing Google Ads : réengagez pour maximiser vos conversions",
    description:
      "Le remarketing Google Ads peut transformer vos prospects en clients. créez des stratégies personnalisées pour réengager vos prospects et augmenter vos conversions.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
